export default function LinkProperty({ meta }) {
  return (
    <div className="meta_box_item" style={{ marginTop: "20px" }}>
      <div className="site_name">{meta?.site_name}</div>
      <a
        href={meta?.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginTop: "-5px", fontSize: "12px" }}
      >
        {meta?.title}
      </a>
      <div className="description">
        {meta?.description?.substring(0, 180)}...
      </div>
      <img src={meta?.image} alt="" />
    </div>
  );
}
